<template>
  <el-form :model="searchForm" size="mini" :inline="true" :rules="formRules">
    <el-col :span="3">
      <el-form-item prop="operatorId">
        <el-cascader  size="mini" clearable  ref="cascader"
                      :placeholder="$t('deviceControl.operatorId')" filterable
                      :options="operatorTree"
                      :props="{ checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="searchForm.operatorId">
        </el-cascader>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="stationCode">
        <el-select :placeholder="$t('deviceControl.stationName')" filterable v-model="searchForm.stationId" clearable>
          <el-option v-for="item in stationsForSelect" :key="item.id"
                     v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="stationCode">
        <el-input :placeholder="$t('siteMonitor.gunCode')" v-model="searchForm.gunCode" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="appointOrderNo">
        <el-input :placeholder="$t('yu-yue-dan-hao')" v-model="searchForm.appointOrderNo" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="customerPhone">
        <el-input :placeholder="$t('ke-hu-shou-ji-hao-ma')" v-model="searchForm.customerPhone" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="appointState">
        <el-select :placeholder="$t('yu-yue-zhuang-tai-0')" v-model="searchForm.appointState" clearable>
          <el-option v-for="item in appointStateForSelect" :key="item.code"
                     v-bind:label="item.message" v-bind:value="item.code"></el-option>
        </el-select>
        <!--<el-input placeholder="预约状态" v-model="searchForm.appointState" clearable></el-input>-->
      </el-form-item>
    </el-col>
    <!--预约单号-->
    <!--客户手机号码-->
    <!--运营商Id（选择）-->
    <!--站点名称-->
    <!--桩编号-->
    <!--充电开始时间-->
    <!--充电结束时间-->
    <!--申请预约时间-->
    <!--预约状态（选择）-->
    <el-col :span="1.5">
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetForm">{{ $t('deviceControl.empty') }}</el-button>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="submitForm"
                   :loading="loading">{{ $t('deviceControl.search') }}
        </el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  import {validateInput} from '../../../../../common/validator'

  export default {
    name: "search",
    data() {
      return {
        formRules: {

          typeModel: [
            {validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,16,true,false,true,false,false,false,false)
              }, trigger: 'blur'}],
          typeName: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,16,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
        }
      }
    },
    props:{
      searchForm:{},
      stationsForSelect: {
        type: Array,
        required: true
      },
      operatorTree:{
        type: Array,
        required: true
      },
      appointStateForSelect: {
        type: Array,
        required: true
      },
      loading: false,
    },
    methods: {
      resetForm() {
        for(let item in this.searchForm) {
          if(this.searchForm[item]){
            this.searchForm[item] = ''
          }
        }
        this.submitForm()
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.searchForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      submitForm(){
        this.$emit("submitForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentRecords/search.vue